import { useContext } from "react";
import { ActiveOrDisableActionContext } from "./ActiveOrDisableActionContext";
function usePrepareActiveOrDisable() {
  const {setUser, setShowModal} = useContext(ActiveOrDisableActionContext);
  return (user: any) => {
    setUser(user);
    setShowModal(true)
  }
}
export default usePrepareActiveOrDisable;
